import { COMPANY } from "./links";

export const COMPLAINTS = {
  slug: "complaints-policy",
  title: "Complaints Policy",
  seoTitle: "Complaints Policy | Marioway Benefits Consultancy Ltd",
  description: "How to make a complaint to Marioway Benefits Consultancy Ltd and how we handle it.",
  intro: `${COMPANY.name} aims to provide a clear, professional and respectful service. If something has gone wrong, we want to know so that we can put it right and improve. This policy explains how to make a complaint and what you can expect from us.`,
  summaryRo: {
    title: "Pe scurt, în română",
    items: [
      "Cum faci o reclamație: scrie la info@mariowayltd.com (subiect „Complaint”) sau pe WhatsApp/telefon la 07383513170. Poți scrie în română.",
      "Ce să incluzi: numele tău, serviciul la care te referi, ce s-a întâmplat și ce rezolvare dorești.",
      "Confirmare: îți confirmăm primirea în 3 zile lucrătoare.",
      "Răspuns: primești un răspuns complet în scris în 15 zile lucrătoare (dacă e nevoie de mai mult timp, te anunțăm).",
      "Dacă nu ești mulțumit: poți cere o reanalizare în 20 de zile lucrătoare; răspunsul final vine în alte 15 zile lucrătoare.",
      "Alte opțiuni: pentru date personale – ICO (ico.org.uk); pentru drepturi de consumator – Citizens Advice (0808 223 1133). Nu suntem membri ai unui ombudsman.",
    ],
  },
  sections: [
    {
      h: "1. How to make a complaint",
      list: [
        `By e-mail: ${COMPANY.email} (preferred — please write "Complaint" in the subject line).`,
        `By telephone or WhatsApp: ${COMPANY.phone}. We may ask you to confirm the complaint in writing so that we have an accurate record.`,
        "You may ask someone else to make the complaint on your behalf. We will need your written permission to discuss your case with them.",
        "You can make a complaint in English, Romanian or Spanish.",
      ],
    },
    {
      h: "2. Information we need",
      list: [
        "Your name and contact details.",
        "The service the complaint relates to and the approximate dates.",
        "What went wrong, in your own words, and any documents or messages that help explain it.",
        "What you would like us to do to resolve the matter.",
      ],
    },
    {
      h: "3. Acknowledgement",
      p: ["We will acknowledge your complaint in writing within 3 working days of receiving it and tell you who is dealing with it."],
    },
    {
      h: "4. Investigation",
      list: [
        "Your complaint will be reviewed by the Director, Florin-Marius Bran, or by another suitable person if the Director was directly involved.",
        "We will look at our file, the communications between us and any information you have provided. We may contact you for further details.",
        "Complaints are handled confidentially and will not affect the service you receive from us.",
      ],
    },
    {
      h: "5. Response times",
      list: [
        "We aim to give you a full written response within 15 working days of acknowledging the complaint.",
        "If the matter is complex and we need more time, we will tell you why, keep you updated, and give you a new date for our response, which will not normally be more than a further 15 working days.",
        "Our response will explain what we found, whether we uphold the complaint, and what action we will take — for example an apology, correction of the work, a partial or full refund, or a change to our procedures.",
      ],
    },
    {
      h: "6. Escalation",
      list: [
        "If you are not satisfied with our response, you may ask for the complaint to be reviewed. Please write to us within 20 working days of our response explaining why you remain dissatisfied. A final review will be completed within a further 15 working days.",
        "Our final review letter will represent our final position on the complaint.",
      ],
    },
    {
      h: "7. External options",
      list: [
        "Marioway is an independent administrative support business and is not currently a member of an ombudsman scheme or regulated by a professional body for the services described on our website. We will update this policy if that changes.",
        "If your complaint is about how we have handled your personal information, you may also contact the Information Commissioner's Office (ico.org.uk · 0303 123 1113).",
        "As a consumer you may seek free advice from Citizens Advice (citizensadvice.org.uk · 0808 223 1133) about your rights, and you retain the right to take a dispute to court.",
      ],
    },
    {
      h: "8. Learning from complaints",
      p: [`We keep a record of complaints and review them regularly to improve our services. Last updated: ${COMPANY.updated}.`],
    },
  ],
};
